import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import BeginningBalanceActions from "../../../../reducers/modules/accounting/beginning-balance/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";
import i18n from "../../../../i18n";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "accounting/beginning-balance";

export default class BeginningBalanceMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.update());
      BeginningBalanceMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.process());
      BeginningBalanceMiddleware.showlist(dispatch, params);
    };
  }

  static reset() {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.reset());
    };
  }

  static resetList() {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.resetList());
    };
  }

  static getOne(params) {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.view());
      BeginningBalanceMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.submit());
      BeginningBalanceMiddleware.saveNew(dispatch, post, search);
    };
  }

  static beforeUploadNew(post, search) {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.submit());
      BeginningBalanceMiddleware.uploadNew(dispatch, post, search);
    };
  }

  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.submit());
      BeginningBalanceMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }

  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.delete());
      BeginningBalanceMiddleware.delete(dispatch, params, id);
    };
  }

  static beforeVoid(id, params) {
    return (dispatch) => {
      dispatch(BeginningBalanceActions.void());
      BeginningBalanceMiddleware.voidData(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      BeginningBalanceMiddleware.showHelper(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BeginningBalanceMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(BeginningBalanceActions.list(response.data.result));
        }
      })
      .catch((error) => {
        BeginningBalanceMiddleware.alertHendler(dispatch, error);
      });
  }

  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BeginningBalanceMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-balance",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(BeginningBalanceActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        BeginningBalanceMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BeginningBalanceMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BeginningBalanceActions.process(),
            BeginningBalanceMiddleware.showlist(dispatch, params)
          );
          BeginningBalanceMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BeginningBalanceMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static voidData(dispatch, params, id, ) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BeginningBalanceMiddleware.getToken()}`,
      },
      url: url + "/cancel/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BeginningBalanceActions.process(),
            BeginningBalanceMiddleware.showlist(dispatch, params)
          );
          BeginningBalanceMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Cancel Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BeginningBalanceMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BeginningBalanceMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BeginningBalanceActions.process(),
            BeginningBalanceMiddleware.showlist(dispatch, search)
          );
          dispatch(BeginningBalanceActions.success());
          BeginningBalanceMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Save Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BeginningBalanceMiddleware.alertHendler(dispatch, error);
      });
  }

  static uploadNew(dispatch, post, search) {
    const formData = new FormData();
    formData.append('file', post.Upload.file);     
    formData.append('branch', post.Upload.idBranch); 
    formData.append('tanggal', post.Upload.date);
    formData.append('store', post.Upload.idStore);
    formData.append('warehouse', post.Upload.idWarehouse);
    axios({
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        Authorization: `Bearer ${BeginningBalanceMiddleware.getToken()}`,
      },
      url: url + '/upload',
      data: formData,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BeginningBalanceActions.process(),
            BeginningBalanceMiddleware.showlist(dispatch, search)
          );
          dispatch(BeginningBalanceActions.success());
          BeginningBalanceMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Save Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BeginningBalanceMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${BeginningBalanceMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            BeginningBalanceActions.process(),
            BeginningBalanceMiddleware.showlist(dispatch, search)
          );
          dispatch(BeginningBalanceActions.success());
          BeginningBalanceMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        BeginningBalanceMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              console.log(data)
              MySwal.hideLoading();
              MySwal.update({
                title: "Error",
                html: i18n.t(data.message),
                icon: "error",
                showConfirmButton: true,
              })
              const search = {limit: 10}
                dispatch(
                  BeginningBalanceActions.process(),
                  BeginningBalanceMiddleware.showlist(dispatch, search)
                );
          
            } else {
              const data = result.response.data;
              dispatch(BeginningBalanceActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(BeginningBalanceActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
